module.exports = __webpack_public_path__ + "images/emoji/bird.8f87655e66372bdb472f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/bird.png
// module id = v7gT
// module chunks = 24